import React, { createElement } from 'react';
import { useRecoilValue } from 'recoil';
import { Route, Routes } from 'react-router-dom';

import DashboardLayout from 'components/layout/DashboardLayout';
import AuthLayout from 'components/layout/AuthLayout';
import Page404 from 'components/layout/Page404';

import modules from 'config/modules';
import { AuthState } from 'models/AuthModel';
import Login from 'modules/auth/Login';
import Register from 'modules/auth/Register';
import PasswordReset from 'modules/auth/PasswordReset';
import ForgotPassword from 'modules/auth/ForgotPassword';
import InvitePasswordMake from 'modules/auth/InvitePasswordMake';
import ToS from 'modules/auth/ToS';
import auth from 'recoil/atoms/auth';


const RouteList = () => {
    const my = useRecoilValue(auth);

    if (my.state === AuthState.Loading)
        return null;

    return (
        <Routes>
            <Route element={<DashboardLayout menuItems={modules}/>}>
                {modules.map(m =>
                    ('module' in m && (!m.permission || my.permissions?.has(m.permission))) ?
                        <Route
                            key={m.path}
                            path={m.path}
                            element={createElement(m.module)}
                        /> :
                        null
                )}
                <Route path="*" element={<Page404/>}/>
            </Route>
            <Route element={<AuthLayout/>}>
                <Route
                    path="login"
                    element={<Login/>}
                />
                <Route
                    path="register"
                    element={<Register/>}
                />
                <Route
                    path="forgot-password"
                    element={<ForgotPassword/>}
                />
                <Route
                    path="/password-reset/:token"
                    element={<PasswordReset/>}
                />
                <Route
                    path="/invite/:token"
                    element={<InvitePasswordMake/>}
                />
                <Route
                    path="tos"
                    element={<ToS/>}
                />
            </Route>
        </Routes>
    );
};

export default RouteList;
